module.exports = __webpack_public_path__ + "media/headLeft3.164699d5.mp4";